import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, TextInput } from '@origo/origo-ui';
import type { PlanInfoFormValues, SelectOption } from '../../../types';
import PageSection from '../../../components/PageSection';
import layout from './PlanInfoLayout.module.css';

type Field = 'saksnummer' | 'forslagsstillerType';

interface CaseSectionProps {
    values: Pick<PlanInfoFormValues, Field>;
    errors?: Partial<Record<Field, string>>;
    forslagsstillerTypeOptions: SelectOption[];
    onChange: (field: Field, value: string) => void;
}

/** Saksnummer og forslagsstiller. Planens låste identifikatorer vises i
 *  topp-raden i PlanDetailShell, ikke her. */
const CaseSection: React.FC<CaseSectionProps> = ({
    values,
    errors = {},
    forslagsstillerTypeOptions,
    onChange,
}) => {
    const { t } = useTranslation();

    return (
        <PageSection title={t('planInfo.sections.case')} asFieldset>
            <div className={layout.twoColumn}>
                <TextInput
                    label={t('newPlan.fields.saksnummer')}
                    placeholder={t('newPlan.fields.saksnummerPlaceholder')}
                    value={values.saksnummer}
                    error={errors.saksnummer}
                    onChange={e => onChange('saksnummer', e.target.value)}
                />
                <Select
                    label={t('newPlan.fields.forslagsstillerType')}
                    placeholder={t('newPlan.fields.forslagsstillerTypePlaceholder')}
                    value={values.forslagsstillerType}
                    error={errors.forslagsstillerType}
                    options={forslagsstillerTypeOptions}
                    onChange={e => onChange('forslagsstillerType', e.target.value)}
                />
            </div>
        </PageSection>
    );
};

export default CaseSection;
